<template>
  <div class="body-wrapper">
    <Header :title="'Brands'" />
    <div class="body-contents">
      <div class="value-container">
        <div class="value-header">
          <h2>Brands</h2>
          <a @click="addBrand = !addBrand">
            {{ addBrand ? 'Cancel' : 'Add' }}
          </a>
        </div>
        <div class="value-body">
          <div v-if="addBrand" class="brand-item add-item">
            <div class="add-attr">
              <label>Name</label>
              <input type="text" v-model="newBrandName"/>
            </div>
            
            <!-- <div class="add-attr">
              <label>Image path</label>
              <input type="text" />
            </div> -->

            <div class="action-buttons">
              <button class="primary" @click="saveCreateBrand()">Create</button>
              <button class="secondary" @click="addBrand = false">Cancel</button>
            </div>
          </div>
          <div class="brand-item" v-for="brand in brands" :key="brand['id']">
            <div class="brand-content">
              <label>Name</label>
              <p v-if="brand != editBrand">{{brand['name']}}</p>
              <div><input v-model="editBrandName" type="text" v-if="brand == editBrand" /></div>
              <!-- TODO -->
              <!-- <label>Image path</label>
              <p>assets/images/adidas.png</p> -->
            </div>
            <a @click="save(brand)" v-if="editBrand === brand">Save </a>
            <a @click="editClicked(brand)">{{ editBrand === brand ? 'Cancel' : 'Edit' }}</a>
            <a @click="deleteClicked(brand)" v-if="editBrand !== brand">Delete</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/header/Header";
import { getBrands, updateBrand, createBrand, deleteBrand } from '@/api/requests';

export default {
  name: 'Values',

  data() {
    return {
      brandName: '',
      brandImage: '',
      addBrand: false,
      editBrand: {},
      editBrandName: '',
      newBrandName: '',
      brands: [],
    };
  },

  mounted() {
    getBrands().then(response => {
      this.brands = response.data;
    }).catch(() => {
      // TODO errors
    });
  },

  methods: {
    editClicked(brand) {
      if (this.editBrand !== brand) {
        this.editBrand = brand;
        this.editBrandName = brand['name'];
      } else {
        this.editBrand = '';
      }
    },

    deleteClicked(brand) {
      if (confirm('Are you sure you want to delete this brand?')) {
        deleteBrand(brand['id']).then(() => {
          const removeIndex = this.brands.map(brand => brand.id)
                       .indexOf(brand['id']);

          ~removeIndex && this.brands.splice(removeIndex, 1);
          this.editBrandName = '';
          this.editBrand = {};
        });
      }
    },

    save(brand) {
      if (brand['name'] !== this.editBrandName) {
        const payload = {
          name: this.editBrandName
        };
        updateBrand(brand['id'], payload).then(() => {
          brand['name'] = this.editBrandName;
          this.editBrandName = '';
          this.editBrand = {};
        });
      } else {
        // Error message
      }
    },

    saveCreateBrand() {
      if (this.newBrandName !== '') {
        const payload = {
          name: this.newBrandName
        };
        createBrand(payload).then((response) => {
          const id = response.data.id;
          this.brands.push({'id': id, 'name': this.newBrandName });
          this.newBrandName = '';
          this.addBrand = false;
        });
      } else {
        // Error message
      }
    }
  },

  components: {
    Header
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";

.body-contents {
  padding: $spacing_base;
  display: flex;
  gap: $spacing_base;

  .value-container {
    flex: 1;
    border: 1px solid $sec7;

    .value-header {
      display: flex;
      background: $sec7;
      padding: $spacing_base;
      
      h2 {
        flex: 1;
        font-size: 1em;
        font-weight: normal;
        padding: 0;
        margin: 0;
        color: $sec0;
      }
    }

    .value-body {
      .add-item {
        flex-direction: column;
        .add-attr {
          display: flex;
          flex-direction: column;
          margin-bottom: $spacing_base;
        }
        label {
          font-weight: bold;
          font-size: .8em;
          color: $sec2;
        }
        .action-buttons {
          display: flex;
          gap: $spacing_base;
          button {
            height: 30px;
          }
          .primary {
            flex: 3;
            background: $blue;
            color: #FFF;
            border: 0;
            border-radius: $border-radius;
            &:hover {
              opacity: .95;
            }
            &:active {
              opacity: 1.1;
            }
          }
          .secondary {
            flex: 1;
          }
        }
      }
      .brand-item {
        border-bottom: 1px solid $sec7;
        padding: $spacing_base;
        display: flex;

        .brand-content {
          flex: 1;
          label {
            font-weight: bold;
            font-size: .8em;
            color: $sec2;
          }
          p {
            padding: 0;
            margin: 0;
            font-size: .9em;
            color: $sec3;
            margin-bottom: $spacing_small;
          }
        }
        
      }
    }
  }
}

a {
  color: $blue;
  font-size: 0.8em;
  cursor: pointer;
  user-select: none;
  margin-left: $spacing_small;
}
</style>
